import React from "react";
import { toVND, formatDate } from "../../helpers/helpers";
import { getOrderStatusClassName, getOrderStatusLabel, getOrderTypeLabel } from "../../constants/orderMappings";

interface OrderItemProps {
    id?: string | number;
    order_no?: string;
    order_number?: string;
    total?: number;
    total_price?: number;
    opened_at?: string;
    created_at?: string;
    status?: string;
    order_type?: string;
    zone_name_snapshot?: string;
    table_number_snapshot?: string | number;
    is_paid?: boolean;
    onSelect?: (orderId: string | number) => void;
}
const OrderItem: React.FC<OrderItemProps> = ({
    id,
    order_no,
    order_number,
    total,
    total_price,
    opened_at,
    created_at,
    status,
    order_type,
    zone_name_snapshot,
    table_number_snapshot,
    onSelect,
}) => {
    const handleSelect = () => {
        if (id && onSelect) {
            onSelect(id);
        }
    };
    const isSelectable = Boolean(id && onSelect);
    const location =
        zone_name_snapshot && table_number_snapshot
            ? `${zone_name_snapshot} - ${table_number_snapshot}`
            : zone_name_snapshot ?? table_number_snapshot ?? "";
    const displayOrderNo = order_no ?? order_number ?? "-";
    const displayTotal = total ?? total_price ?? 0;
    const displayOpenedAt = opened_at ?? created_at ?? "";
    const statusClassName = getOrderStatusClassName(status);

    return (
        <React.Fragment>
            <div
                className={`product-description w-100-v2 mw-100-v2 p-2${isSelectable ? " cursor-pointer" : ""}`}
                onClick={isSelectable ? handleSelect : undefined}
                role={isSelectable ? "button" : undefined}
                tabIndex={isSelectable ? 0 : undefined}
                onKeyDown={
                    isSelectable
                        ? (event) => {
                              if (event.key === "Enter" || event.key === " ") {
                                  event.preventDefault();
                                  handleSelect();
                              }
                          }
                        : undefined
                }
            >
                <span className="product-title d-block fw-bold fs-5">Mã đơn: {displayOrderNo}</span>

                <p className="fw-bold mb-1">
                    Tổng tiền : {toVND(displayTotal)}
                </p>

                <p className="fw-bold mb-1">
                    Đặt lúc : {displayOpenedAt ? formatDate(displayOpenedAt, "HH:mm:ss") : "-"}
                </p>

                <p className="fw-bold mb-1">
                    Trạng thái : <span className={`fw-bold ${statusClassName}`}>{getOrderStatusLabel(status)}</span>
                </p>

                <p className="fw-bold mb-1">
                    Khách muốn : {getOrderTypeLabel(order_type)}
                </p>

                <p className="fw-bold mb-1">
                    Vị trí : {location || "-"}
                </p>
            </div>
        </React.Fragment>
    );
};

export default OrderItem;
